<template>
  <div>
    <v-row>
      <v-tabs v-model="activeTab" style="border-bottom: 1px solid var(--v-borderColor-base);">
        <v-tab active-class="selected-tab" class="px-6" @click="selectTab('custom_fields_devices')">
          {{ $t("assets.tabs.devicesTab") }}
        </v-tab>
        <v-tab active-class="selected-tab" class="px-6" @click="selectTab('custom_fields_locations')">
          {{ $t("assets.tabs.locationsTab") }}
        </v-tab>
         <v-tab active-class="selected-tab" class="px-6" @click="selectTab('custom_fields_operators')">
          {{ $t("assets.tabs.operatorsTab") }}
        </v-tab>
      </v-tabs>
    </v-row>
    <div class="container">
      <div class="scrollable-content">
        <v-row class="justify-center">
          <v-col v-if="this.$route.name === 'custom_fields_locations'" cols="12" class="mb-0 pb-0 pt-1">
            <CustomFieldItem
              v-for="(customField, index) in this.getCustomFields"
              :key="index"
              :field="customField"
              @update-field="updateField"
            />
          </v-col>
          <v-col v-else-if="this.$route.name === 'custom_fields_devices'" cols="12" class="mb-0 pb-0 pt-1">
            <CustomFieldItem
              v-for="(customField, index) in this.getCustomFieldsDevices"
              :key="index"
              :field="customField"
              @update-field="updateField"
            />
          </v-col>
          <v-col v-else cols="12" class="mb-0 pb-0 pt-1">
            <CustomFieldItem
              v-for="(customField, index) in this.getCustomFieldsOperator"
              :key="index"
              :field="customField"
              @update-field="updateField"
            />
          </v-col>
        </v-row>
      </div>
      <v-row class="button-row justify-end ml-4">
        <v-col cols="auto">
          <v-btn large class="text-capitalize mr-4" color="secondary">{{ $t('assets.working_time.button.cancel') }}</v-btn>
          <v-btn large class="text-capitalize" color="primary" @click="handleSave">{{ $t('assets.working_time.button.save') }}</v-btn>
        </v-col>
      </v-row>
    </div>
    <Alert class="bottom-alert"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Alert from '../components/Alert';
import CustomFieldItem from '../components/CustomFields/CustomFieldItem.vue';
import Locations from "../services/api/Locations";

export default {
  components: {
    CustomFieldItem,
    Alert
  },
  data() {
    return {
      activeTab: 0,
      updatedCustomFields: []
    };
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(name) {
        const map = {
          'custom_fields_devices': 0,
          'custom_fields_locations': 1,
          'custom_fields_operators': 2,
        };
        if (name in map) this.activeTab = map[name];
      }
    }
  },
  mounted() {
    this.initializeCustomFields();
  },
  methods: {
    ...mapActions({
      addAlert: "global/addAlert",
      customFields: "locations/getSpaceCustomFields",
    }),
    initializeCustomFields() {
      this.customFields(); // Fetch the initial fields
    },

    updateField(index, updatedField) {
      // Determine which custom fields array to update based on current route
      const isOperatorsTab = this.$route.name === 'custom_fields_operators';
      const isDevicesTab = this.$route.name === 'custom_fields_devices';
      let sourceFields;
      if (isOperatorsTab) {
        sourceFields = this.getCustomFieldsOperator;
      } else if (isDevicesTab) {
        sourceFields = this.getCustomFieldsDevices;
      } else {
        sourceFields = this.getCustomFields;
      }

      let data = this.updatedCustomFields.length
        ? [...this.updatedCustomFields]
        : [...sourceFields];
      
      const fieldIndex = data.findIndex(field => field.index === index);
      if (fieldIndex !== -1) {
        data[fieldIndex] = { ...data[fieldIndex], ...updatedField };
        this.updatedCustomFields = [...data];
      } else {
        console.warn(`Field with index ${index} not found.`);
      }
    },

    selectTab(routeName) {
      if (this.$route.name === routeName) {
        return;
      }
      this.updatedCustomFields = [];
      this.$router.push({ name: routeName });
    },

    handleSave() {
      const isOperatorsTab = this.$route.name === 'custom_fields_operators';
      const isDevicesTab = this.$route.name === 'custom_fields_devices';
      if (this.updatedCustomFields.length > 0) {
        this.saveCustomFields(this.updatedCustomFields, isOperatorsTab, isDevicesTab);
      } else {
        console.warn('No changes made to custom fields.');
      }
    },
    parseServerErrors(errorData) {
      let errors = [];

      if (!errorData || typeof errorData !== 'object') {
        return ['Unknown server error'];
      }

      // 1. Ako postoji "non_field_errors" kao lista
      if (Array.isArray(errorData.non_field_errors)) {
        errors.push(...errorData.non_field_errors);
      }

      if (typeof errorData.message === 'string') {
        errors.push(errorData.message);
      }

      Object.keys(errorData).forEach(key => {
        if (key !== 'non_field_errors' && key !== 'message') {
          const fieldErrors = errorData[key];
          if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach(err => {
              errors.push(`${key}: ${err}`);
            });
          }
        }
      });

      if (errors.length === 0) {
        errors.push('Unknown server error');
      }

      return errors;
    },
    saveCustomFields(fields, isOperatorsTab, isDevicesTab) {
      const prefix = isOperatorsTab ? 'operator' : isDevicesTab ? 'device' : 'location';
      const payload = fields.reduce((acc, field) => {
        acc[`${prefix}_custom_${field.index}_alias`] = field.alias;
        acc[`${prefix}_custom_${field.index}_enabled`] = field.enabled;
        acc[`${prefix}_custom_${field.index}_required`] = field.required;
        acc[`${prefix}_custom_${field.index}_unique`] = field.unique;
        return acc;
      }, {});
      
      Locations.editSpace(null, payload)
        .then(response => {
          if (response && response.data) {
            this.addAlert({ message: 'Custom fields updated successfully!', type: 'success' });
            // Reset updated fields after successful save
            this.updatedCustomFields = [];
            // Refresh custom fields data from server
            this.customFields();
          } else {
            console.error('Unexpected response structure:', response);
            this.addAlert({ message: 'Failed to update custom fields: Unexpected response structure.', type: 'error' });
          }
        })
        .catch(error => {
          console.error('Failed to update custom fields:', error);
          
          if (error.response && error.response.data) {
            const parsedErrors = this.parseServerErrors(error.response.data);
            this.addAlert({ message: `Failed to update custom fields: ${parsedErrors.join(' | ')}`, type: 'error' });
          } else {
            this.addAlert({ message: 'Failed to update custom fields: Unknown error.', type: 'error' });
          }
        });
    },
  },
  computed: {
    ...mapGetters({
      getCustomFields: "locations/getCustomFields",
      getCustomFieldsOperator: "locations/getCustomFieldsOperator",
      getCustomFieldsDevices: "locations/getCustomFieldsDevices",
    }),
    operatorCustomFields() {
      return this.getCustomFieldsOperator;
    }
  }
};
</script>

<style scoped>
.container {
  width: 60%;
  display: flex;
  flex-direction: column;
}
.scrollable-content {
  max-height: calc(82vh - 120px); /* or whatever maximum height you want */
  overflow-y: auto;  /* make it scrollable when content overflows */
}
.top-text {
  width: 100%;
}
.top-text h3, .top-text span {
  margin: 0;
}

.button-row {
  width: 100%;
  justify-content: flex-end;
}
.bottom-alert {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
@media screen and (max-width: 1000px){
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
}
</style>
